import { useEffect, useState } from 'react';
import { TRANSCRIPTION_STATUS } from './sessionState';

// Coincideix amb la durada de l'animació de passos de TranscriptionProgress.
export const MINIMUM_PROGRESS_MS = 10_000;

const ACTIVE = new Set([TRANSCRIPTION_STATUS.PREPARING, TRANSCRIPTION_STATUS.TRANSCRIBING]);

// Retorna true mentre un resultat ja complet s'ha d'amagar perquè la càrrega
// encara no ha durat el mínim. L'estat s'ajusta durant el render perquè el
// resultat no aparegui ni un sol frame abans d'hora.
export function useMinimumProgress(status, minimumMs = MINIMUM_PROGRESS_MS) {
  const [startedAt, setStartedAt] = useState(null);
  const [released, setReleased] = useState(false);
  const active = ACTIVE.has(status);

  if (active && startedAt === null) {
    setStartedAt(Date.now());
    if (released) setReleased(false);
  }
  if (!active && status !== TRANSCRIPTION_STATUS.COMPLETE && startedAt !== null) {
    setStartedAt(null);
  }

  const holding = status === TRANSCRIPTION_STATUS.COMPLETE
    && startedAt !== null
    && !released
    && Date.now() < startedAt + minimumMs;

  useEffect(() => {
    if (!holding) return undefined;
    const timer = window.setTimeout(() => setReleased(true), startedAt + minimumMs - Date.now());
    return () => window.clearTimeout(timer);
  }, [holding, minimumMs, startedAt]);

  return holding;
}
